import type { ICellRendererComp, ICellRendererParams } from "ag-grid-enterprise";

interface IconBadgeCellRendererParams extends ICellRendererParams {
  // Row-data field holding the badge label. Blank/absent → the value renders alone.
  badgeField?: string;
  // Font Awesome classes for the icon placed before the badge label.
  iconClass?: string;
}

// Value on line one, an optional icon+label badge on line two. The badge never enters
// `params.value`, so sort/filter/copy still see only the bare value.
export class IconBadgeCellRenderer implements ICellRendererComp {
  private eGui!: HTMLElement;

  init(params: IconBadgeCellRendererParams): void {
    this.eGui = document.createElement("div");
    this.eGui.className = "ag-icon-badge-cell";

    const valueEl = document.createElement("div");
    valueEl.textContent = params.value == null ? "" : String(params.value);
    this.eGui.appendChild(valueEl);

    const data = params.data as Record<string, unknown> | undefined;
    const label = params.badgeField ? (data?.[params.badgeField] as string | undefined) : undefined;
    if (!label) return;

    const badge = document.createElement("div");
    badge.className = "ag-icon-badge-cell__badge";
    if (params.iconClass) {
      const icon = document.createElement("i");
      icon.className = params.iconClass;
      icon.setAttribute("aria-hidden", "true");
      badge.appendChild(icon);
      badge.appendChild(document.createTextNode(" "));
    }
    badge.appendChild(document.createTextNode(label));
    this.eGui.appendChild(badge);
  }

  getGui(): HTMLElement {
    return this.eGui;
  }

  refresh(): boolean {
    return false;
  }
}
